import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetMigrationsYClientsQuery } from '@app/api/Migration';
import { DATA_MIGRATION_PATH } from '@app/constants';
import {
  useNewUserAccessRights,
  useUserPrint,
  useWindowSize,
} from '@app/hooks';
import { useErrorHandler } from '@app/shared/hooks';

import { adaptDataToTable } from '@pages/DataMigration/utils/adaptDataToTable';

export const useDataMigration = () => {
  const { activeBranchId } = useUserPrint();
  const navigate = useNavigate();
  const { isMobile } = useWindowSize();
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const {
    userAccessRights: { DataMigrations },
  } = useNewUserAccessRights();

  const hasUserRightForModuleView = useMemo(
    () => DataMigrations?.IsOn,
    [DataMigrations]
  );

  const {
    data: migrationsList,
    isFetching: isRegistryLoading,
    isError,
    error,
  } = useGetMigrationsYClientsQuery(
    { ActiveBranchId: activeBranchId! },
    { skip: !activeBranchId }
  );

  useErrorHandler([{ flag: isError, error }]);

  const handleChange = useCallback((page: number, pageSize: number) => {
    setPageNumber(page);
    setRowsPerPage(pageSize);
  }, []);

  const handleNavigateToCard = useCallback(
    (legalEntityId: number) => {
      navigate(`${DATA_MIGRATION_PATH}/card/?id=${legalEntityId}`);
    },
    [navigate]
  );

  const dataSource = useMemo(
    () => adaptDataToTable(migrationsList || [], handleNavigateToCard),
    [migrationsList, handleNavigateToCard]
  );

  return {
    isRegistryLoading,
    hasUserRightForModuleView,
    isMobile,
    pageNumber,
    rowsPerPage,
    handleChange,
    dataSource,
  };
};
